import React, { Component } from "react";
import "./App.css";
import "./chartist.css";
import IconTabs from "./Components/Router/IconTabs.jsx";
import theme from "./AppTheme.jsx";
import { HashRouter } from "react-router-dom";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import ErrorBoundary from "./Components/Handlers/ErrorBoundary";

import firebase from "firebase/app";
import ReactGA from "react-ga";

class App extends Component {
  componentWillMount = () => {
    var config = {
      apiKey: "AIzaSyBJHFbzXPZMqO1BOwtOohS_BonTYUlzfOM",
      authDomain: "ggc5km.firebaseapp.com",
      databaseURL: "https://ggc5km.firebaseio.com",
      projectId: "ggc5km",
      storageBucket: "ggc5km.appspot.com",
      messagingSenderId: "534285416091"
    };
    firebase.initializeApp(config);

    ReactGA.initialize("UA-130562291-1");
    ReactGA.set({ userId: "runner" });
    ReactGA.pageview("/");
  };

  render() {
    return (
      <ErrorBoundary>
        <MuiThemeProvider theme={createMuiTheme(theme)}>
          <HashRouter>
            <IconTabs />
          </HashRouter>
        </MuiThemeProvider>
      </ErrorBoundary>
    );
  }
}

export default App;
